(() => {
  const watchedRoots = new WeakSet();
  let queued = false;
  let pendingOpen = false;
  let addressOpenRequested = false;
  const isFavorites = link => {
    try { return new URL(link.href, location.href).hash === '#hero-wishlist'; }
    catch { return false; }
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  };
  const sync = () => {
    const counters = Array.from(document.querySelectorAll('.wishlist-hero-items-count'));
    const activeCounter = counters.find(counter => counter.classList.contains('wishlist-hero-items-count-exists'));
    const digits = activeCounter?.textContent.match(/\d+/)?.[0];
    let count = digits === undefined ? 0 : Number(digits);
    let ready = counters.length > 0;
    try {
      const stored = JSON.parse(localStorage.getItem('wishlisthero_.wl-itms'));
      if (Array.isArray(stored)) {
        count = stored.length;
        ready = true;
      }
    } catch {}
    document.querySelectorAll('shopify-account').forEach(account => {
      const root = account.shadowRoot;
      if (!root) return;
      if (!watchedRoots.has(root)) {
        watchedRoots.add(root);
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
      }
      root.querySelectorAll('a.account__item').forEach(link => {
        if (!isFavorites(link)) return;
        const label = link.querySelector('.account__item-text');
        const name = document.documentElement.lang.startsWith('fr') ? 'Favoris' : 'Wishlist';
        const text = ready ? `${name} (${count})` : name;
        if (label && label.textContent !== text) label.textContent = text;
      });
      const accountRow = document.querySelector('.bz-mobile-menu-link');
      const shortcuts = Array.from(root.querySelectorAll('a.account__item'));
      if (!accountRow || !shortcuts.length) return;
      let submenu = accountRow.querySelector('.bz-mobile-account-items');
      if (!submenu) {
        submenu = document.createElement('ul');
        submenu.className = 'bz-mobile-account-items';
        accountRow.append(submenu);
      }
      if (!accountRow.querySelector('.bz-account-toggle')) {
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bz-account-toggle';
        toggle.setAttribute('aria-label', document.documentElement.lang.startsWith('fr') ? 'Afficher ou masquer les liens du compte' : 'Show or hide account links');
        toggle.setAttribute('aria-expanded', 'true');
        submenu.id = 'bz-mobile-account-shortcuts';
        toggle.setAttribute('aria-controls', submenu.id);
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          submenu.hidden = expanded;
          accountRow.closest('header-drawer')?.updateMenuHeight?.();
        });
        accountRow.insertBefore(toggle, submenu);
      }
      shortcuts.forEach((link, index) => {
        let item = submenu.children[index];
        if (!item) {
          item = document.createElement('li');
          item.append(link.cloneNode(true));
          submenu.append(item);
        }
        const shortcut = item.querySelector('a');
        if (shortcut.href !== link.href) shortcut.href = link.href;
        const label = shortcut.querySelector('.account__item-text');
        const originalLabel = link.querySelector('.account__item-text');
        if (label && originalLabel && label.textContent !== originalLabel.textContent) label.textContent = originalLabel.textContent;
      });
      while (submenu.children.length > shortcuts.length) submenu.lastElementChild.remove();
    });
  };
  const open = () => {
    if (!window.WishListHero_SDK?.OpenWishList) {
      pendingOpen = true;
      return;
    }
    window.WishListHero_SDK.OpenWishList();
    pendingOpen = !document.querySelector('.wishlist-hero-header-close');
    schedule();
  };
  document.addEventListener('click', event => {
    const link = event.composedPath().find(node => node instanceof Element && node.matches('a.account__item'));
    if (!link || !isFavorites(link)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    link.getRootNode().querySelector('.account__close')?.click();
    if (link.closest('.bz-mobile-account-items')) link.closest('header-drawer')?.close();
    requestAnimationFrame(open);
  }, true);
  ['wishlist-hero-wishlist-updated', 'wishlist-hero-links-binded'].forEach(type => document.addEventListener(type, schedule));
  document.addEventListener('wishlist-hero-wishlist-sdk-ready', () => {
    schedule();
    if (pendingOpen) requestAnimationFrame(open);
  });
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  customElements.whenDefined('shopify-account').then(schedule);
  const openFromAddress = () => {
    if (location.hash !== '#hero-wishlist' || addressOpenRequested) return;
    addressOpenRequested = true;
    requestAnimationFrame(open);
  };
  window.addEventListener('hashchange', openFromAddress);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('storage', event => { if (event.key === 'wishlisthero_.wl-itms') schedule(); });
  window.setInterval(() => {
    if (!document.hidden) {
      schedule();
      openFromAddress();
      if (pendingOpen) open();
    }
  }, 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.addEventListener('click', schedule, true);
  sync();
  openFromAddress();
})();

// Match the collection/inspiration mobile density control in search and Wishlist Hero.
(() => {
  const style = document.createElement('style');
  style.textContent = `
    .bz-shared-grid-tools,.bz-shared-grid-toggle {display:none}
    @media(max-width:749px){
      .bz-shared-grid-tools{display:flex;grid-column:1/-1;justify-content:flex-end;padding:0 var(--page-margin,16px) 8px}
      .bz-shared-grid-tools--inline{padding:0}
      main[data-template^="search"] .column-options-wrapper:has([name="grid-mobile"]){display:none}
      .bz-shared-grid-toggle{display:grid;place-items:center;flex:0 0 36px;width:36px;min-height:44px;padding:0;border:0;border-radius:3px;background:transparent;color:#4d5545;cursor:pointer}
      .bz-shared-grid-toggle:hover{background:#f2f1ed}
      .bz-shared-grid-toggle:focus-visible{outline:2px solid #71825f;outline-offset:2px}
      .bz-shared-grid-toggle [data-single-icon]{display:none}
      .bz-shared-grid-toggle[aria-pressed="true"] [data-single-icon]{display:block}
      .bz-shared-grid-toggle[aria-pressed="true"] [data-double-icon]{display:none}
      .bz-shared-grid-toggle[hidden],.bz-shared-grid-tools[hidden]{display:none}
      main[data-template^="search"] .product-grid[data-bz-shared-columns="1"]{grid-template-columns:minmax(0,1fr)}
      main[data-template^="search"] .product-grid[data-bz-shared-columns="2"]{grid-template-columns:repeat(2,minmax(0,1fr))}
      .MuiDialog-paper[data-bz-shared-columns] .wishlist-hero-header{position:relative}
      .MuiDialog-paper[data-bz-shared-columns] .wishlist-hero-header .bz-shared-grid-toggle{position:absolute;right:62px;top:50%;transform:translateY(-50%)}
      .MuiDialog-paper[data-bz-shared-columns] :has(> .wishlist-hero-list-card){display:grid!important;gap:12px;align-items:start}
      .MuiDialog-paper[data-bz-shared-columns="1"] :has(> .wishlist-hero-list-card){grid-template-columns:minmax(0,1fr)}
      .MuiDialog-paper[data-bz-shared-columns="2"] :has(> .wishlist-hero-list-card){grid-template-columns:repeat(2,minmax(0,1fr))}
      .MuiDialog-paper[data-bz-shared-columns] .wishlist-hero-list-card{flex-basis:auto!important;max-width:100%!important;width:100%;min-width:0;padding:0!important}
      .MuiDialog-paper[data-bz-shared-columns="2"] .wishlist-hero-list-card-header-product-name{font-size:13px!important;line-height:1.4!important}
      .MuiDialog-paper[data-bz-shared-columns="2"] .wishlist-hero-list-card-footer .MuiButton-root{font-size:11px!important;line-height:1.3!important;padding:6px!important;min-width:0;white-space:normal}
      .MuiDialog-paper[data-bz-shared-columns="2"] .wishlist-hero-list-card-footer .MuiButtonGroup-root{display:flex;flex-direction:column;align-items:stretch}
    }`;
  document.head.append(style);
  let queued = false;
  const columns = () => { try { return sessionStorage.getItem('brazur-mobile-columns') === '1' ? '1' : '2'; } catch { return '2'; } };
  const makeButton = () => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bz-shared-grid-toggle';
    button.setAttribute('aria-label', document.documentElement.lang.startsWith('en') ? '1 column' : '1 colonne');
    button.innerHTML = '<svg data-single-icon width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="4" y="2" width="16" height="8" rx="1"/><rect x="4" y="14" width="16" height="8" rx="1"/></svg><svg data-double-icon width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="7" height="18" rx="1"/><rect x="14" y="3" width="7" height="18" rx="1"/></svg>';
    button.addEventListener('click', () => {
      const next = button.getAttribute('aria-pressed') === 'true' ? '2' : '1';
      try { sessionStorage.setItem('brazur-mobile-columns', next); } catch { /* The current view can still switch. */ }
      sync(next);
    });
    return button;
  };
  const update = (target, button, value) => {
    if (target.dataset.bzSharedColumns !== value) target.dataset.bzSharedColumns = value;
    const pressed = String(value === '1');
    if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    const english = document.documentElement.lang.startsWith('en');
    button.title = value === '1' ? (english ? '2 columns' : '2 colonnes') : (english ? '1 column' : '1 colonne');
  };
  const sync = (value = columns()) => {
    for (const grid of document.querySelectorAll('main[data-template^="search"] .product-grid')) {
      const native = grid.closest('.shopify-section')?.querySelector('.column-options-wrapper:has([name="grid-mobile"])');
      const results = native || grid.closest('#ResultsList') || grid;
      let tools = results.previousElementSibling;
      if (!tools?.classList.contains('bz-shared-grid-tools')) {
        tools = document.createElement('div'); tools.className = 'bz-shared-grid-tools' + (native ? ' bz-shared-grid-tools--inline' : '');
        tools.append(makeButton()); results.before(tools);
      }
      update(grid, tools.querySelector('button'), value);
    }
    for (const header of document.querySelectorAll('.wishlist-hero-header')) {
      const modal = header.closest('.MuiDialog-paper');
      if (!modal) continue;
      const cards = modal.querySelectorAll('.wishlist-hero-list-card');
      let button = header.querySelector('.bz-shared-grid-toggle');
      if (!cards.length && !button) continue;
      if (!button) { button = makeButton(); header.append(button); }
      if (button.hidden !== (cards.length === 0)) button.hidden = cards.length === 0;
      update(modal, button, value);
    }
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  };
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('wishlist-hero-wishlist-updated', schedule);
  sync();
})();
